module.exports = __webpack_public_path__ + "img/route_6_s.87b04fc2.png";